import React, {useEffect, useState} from 'react';
import {Autocomplete, TextField} from '@mui/material';

const SingleSelectAutocomplete = ({
  options,
  name = '',
  value = null,
  placeholder = 'Type to filter...',
  onChange = (e: any, value: any) => {},
  renderValueLabelStartAdorment = (
    option: any,
    isRenderingOption?: boolean
  ): any => undefined,
}) => {
  const [state, setState] = useState<any>(value);
  // Sample options - replace with your own data as needed
  useEffect(() => {
    setState(value);
  }, [value]);
  return (
    <>
      <Autocomplete
        options={options} // Options to display in the dropdown
        value={state} // Controlled selected option
        onChange={(_, newValue) => {
          onChange(_, newValue);
        }} // Update selected option
        getOptionLabel={option => option?.label ?? ''} // Display label for each option
        isOptionEqualToValue={(option, value) =>
          option.value === value || option.value === value?.value
        } // Ensure correct option is selected
        renderInput={params => {
          return (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                startAdornment: renderValueLabelStartAdorment
                  ? renderValueLabelStartAdorment(state)
                  : params.InputProps.startAdornment,
              }}
              name={name}
              variant="outlined"
              hiddenLabel
              placeholder={placeholder}
              sx={{
                '.MuiOutlinedInput-root': {
                  padding: '1px 14px',
                },
              }}
            />
          );
        }}
        renderOption={(props, option) => {
          const {key, ...otherProps} = props;
          return (
            <li key={option.value} {...otherProps}>
              {renderValueLabelStartAdorment(option, true)}
              {option.label}
            </li>
          );
        }}
        fullWidth // Optional: Makes the Autocomplete full-width
      />
    </>
  );
};

export default SingleSelectAutocomplete;
